import React from 'react'
import Tab from '@material-ui/core/Tab'
import styles from './styles'
import { withStyles } from '@material-ui/core'

export default withStyles(styles)(Tab)
